import React from "react";
import { useContent } from '../contexts/ContentContext';
import '../assets/styles/Leadership.scss';

function Leadership() {
  const { content } = useContent();
  const leaderships = content.leadership;

  return (
    <div className="leadership-container" id="leadership">
      <div className="items-container">
        <div className="section-code-header">
          <span className="code-keyword">function</span>
          <span className="code-variable">leadershipImpact</span>
          <span className="code-bracket">()</span>
          <span className="code-bracket">{`{`}</span>
        </div>
        <p className="section-comment">// Leadership roles that delivered measurable impact across teams and product strategy</p>
        <div className="leadership-grid">
          {leaderships.map((lead, index) => (
            <div key={index} className="leadership-card">
              <div className="leadership-header">
                <h3 className="leadership-title">{lead.title}</h3>
              </div>
              <p className="leadership-description">{lead.description}</p>
              <div className="leadership-impact">
                <h4>Impact</h4>
                <div className="impact-items">
                  {lead.impact.map((impact, idx) => (
                    <span key={idx} className="code-badge">{impact}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="section-code-footer">{`}`}</div>
      </div>
    </div>
  );
}

export default Leadership;